import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';

const AlternateDatePicker = ({ label, id ,name,value, onChange }) => {
    const [dateValue, setDateValue] = useState('');
    useEffect(() => {
        if (value!=null && value!=="") {
            setDateValue(value);
        }else{
          setDateValue('');
        }
      }, [value]);

      const formatDate = (date) => {
        if (!date) return null; // Handle null case
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      const handleDateChange = (newValue) => {
        setDateValue(newValue);
        onChange({
          target: {
            name,
            value: newValue?formatDate(newValue):'', // Assuming you want to send just the start date
          },
        });
      };

      const isLabelActive = !!dateValue;
      
  return (
    <div className="relative h-9 w-full border">
      <DatePicker 
     // showIcon={true}
    //   readOnly={true}
    autoComplete={'off'}
        selected={dateValue}
        name={name}
        onChange={handleDateChange}
        dateFormat="yyyy-MM-dd"
        className={{
            input: `block h-9  w-full border-b-2 bg-transparent text-gray-900 focus:ring-0 focus:border-blue-500 
                    ${isLabelActive ? 'pt-6' : 'pt-3'}`
          }}
      />
      <label
         htmlFor={id}
         className={`absolute left-3 px-1 transition-all duration-200 ease-in-out bg-white pointer-events-none
           ${isLabelActive
             ? '-top-3.5  text-sm peer-focus:text-blue-500' 
             //: 'top-2.5 text-base text-gray-400'
             :''}
         `}
      >
        {label}
      </label>
    </div>
  );
};

export default AlternateDatePicker;
